export type SentinelErrorCode =
  | 'unauthenticated' | 'step_up_required' | 'mfa_required' | 'forbidden'
  | 'rate_limited' | 'validation' | 'network' | 'unknown';

export class SentinelApiError extends Error {
  constructor(
    public code: SentinelErrorCode,
    message: string,
    public status: number,
    public detail?: unknown,
  ) { super(message); this.name = 'SentinelApiError'; }
}
